// @ vendors
const { Promise } = require('es6-promise');
const get = require('lodash/object/get');
const set = require('lodash/object/set');
const map = require('lodash/collection/map');
const filter = require('lodash/collection/filter');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

const requestCoHolderInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_COHOLDER_REQUEST
});

const requestCoHolderSuccess = (data) => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_COHOLDER_SUCCESS,
    data: data
});

const requestCoHolderFailure = (error) => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_COHOLDER_FAILURE,
    data: {
        error
    }
});

const requestCoHolders = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestCoHolder;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        dispatch(requestCoHolderInProgress());
        return APIGet(dispatch, apiURLBuilder.getURL('mortgageRequestCoHolderInfo'))
        .then( (response) => {
            const coholderList = get(response, 'data', []);

            const data = map(coholderList, coholder => {
                const coHolders = get(coholder, 'intervinientes.listaConsultaTitu.datoConsultaTitu', []);
                const coHoldersFilter = filter(coHolders, obj => {
                    const tipoDocumentoIdentidad = get(obj, 'identifDocumento.tipodocumentoofic', 'UNKNOWN');
                    const identificador = get(obj, 'identifDocumento.codigodedocumento', 'UNKNOWN');
                    const numclienteobcd = get(obj, 'identifPersona.codigodepersona', 'UNKNOWN');
                    return (tipoDocumentoIdentidad !== '' && tipoDocumentoIdentidad !== 'UNKNOWN')
                        && (identificador !== '' && identificador !== 'UNKNOWN')
                        && (numclienteobcd !== '' && numclienteobcd !== 'UNKNOWN');
                });

                set( coholder, 'intervinientes.listaConsultaTitu.datoConsultaTitu', coHoldersFilter );
                return coholder;
            });
            const filtered_response = {
                data: data
            };

            dispatch(requestCoHolderSuccess(filtered_response))
        })
        .catch( (response) => {
            if (!!response.error) {
                dispatch(requestCoHolderFailure(response.error))
            } else {
                throw response;
            }
        });
    } else {
        return Promise.resolve()
    }
};

module.exports = {
    requestCoHolders
};
